import { FOOTER } from "@/constants/testIds";

const YEAR = new Date().getFullYear();

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.container}
      className="relative border-t border-white/[0.06] bg-[#050A08] pt-20 pb-10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-start pb-14">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2 mb-6">
              <span className="relative w-9 h-9 rounded-full overflow-hidden">
                <span
                  className="absolute inset-0"
                  style={{
                    background:
                      "radial-gradient(circle at 30% 30%, #A7F3D0 0%, #00D084 40%, #065F46 100%)",
                    borderRadius: "42% 58% 60% 40% / 40% 45% 55% 60%",
                  }}
                />
              </span>
              <span className="font-display font-bold text-white text-lg">
                Dove<span className="text-emerald-400">.</span>Infotech
              </span>
            </div>
            <p className="text-white/60 max-w-md text-base leading-relaxed">
              A quiet studio building distinctive software since 2005. Web, mobile,
              cloud, UX, video, and AI — under one senior team.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.24em] text-white/40 mb-4">
              Contact
            </div>
            <a
              data-testid={FOOTER.emailLink}
              href="mailto:subharuphazra76@gmail.com"
              className="link-underline text-white/85 text-base"
            >
              subharuphazra76@gmail.com
            </a>
            <div className="mt-4 text-white/50 text-sm">Remote · Worldwide</div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.24em] text-white/40 mb-4">
              Navigate
            </div>
            <ul className="space-y-2 text-white/75 text-sm">
              <li><a className="link-underline" href="#work">Selected work</a></li>
              <li><a className="link-underline" href="#services">Services</a></li>
              <li><a className="link-underline" href="#about">Manifesto</a></li>
              <li><a className="link-underline" href="#contact">Start a project</a></li>
            </ul>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="overflow-hidden pt-4 pb-2 border-t border-white/[0.06]">
          <div className="font-display font-black tracking-tighter text-white/[0.06] text-[7vw] leading-[0.85] select-none whitespace-nowrap">
            DOVE INFOTECH
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/40">
          <div>© {YEAR} Dove Infotech Private Limited. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span>Crafted since 2005</span>
            <span className="inline-block w-1 h-1 rounded-full bg-emerald-400" />
            <span>Made with obsession</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
